import { render, staticRenderFns } from "./MarketSegmentField.vue?vue&type=template&id=379442a4"
import script from "./MarketSegmentField.vue?vue&type=script&lang=js"
export * from "./MarketSegmentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports